<script setup>
import DefaultPanel from '@/components/DefaultPanel.vue';
import LoadingComponent from '@/components/LoadingComponent.vue';
import { usePopupStore } from '@/store/alertpopup-store';
import { useRouterStore } from '@/store/router-store';
import { onErrorCaptured, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const router = useRouter();
const route = useRoute();
const routerStore = useRouterStore();
const popupStore = usePopupStore();
// const isLoading = ref(true);

onMounted(async () => {
    // try {
    //     if (!routerStore.isInitialized) {
    //         await routerStore.fetchRouterItems();
    //         await addDynamicRoutes(router, routerStore.routerList);
    //         routerStore.setInitialized(true);
    //     }
    //     await router.isReady();
    // } catch (error) {
    //     console.error('Error in mounted hook:', error);
    // }
});

onErrorCaptured((error) => {
    console.error('error:', error);
    return true;
});

// watch(
//     () => routerStore.routerList,
//     (newValue, oldValue) => {
//         if (newValue !== oldValue) {
//             addDynamicRoutes(router, newValue);
//         }
//     },
//     { deep: true }
// );
</script>

<template>
    <LoadingComponent />
    <router-view />
    <!--router.push({ name: 'page', query: { id: 1, name: 'test' } });  쿼리파라미터-->
    <DefaultPanel v-if="popupStore.isVisible" :title="popupStore.title" height="15rem" @close="popupStore.hidePopup">
        {{ popupStore.message }}
    </DefaultPanel>
</template>
